import React, { Component } from 'react';
import Card from 'react-bootstrap/Card';

var firebase = require('firebase/app');
require('firebase/auth');
require('firebase/firestore');

var Link = require('react-router-dom').Link;

export class SearchItem extends Component {
  constructor(props) {
    super(props);

    this.db = firebase.firestore();
    this.storage = firebase.storage();

    // Bind products
    this.getHeader = this.getHeader.bind(this);
    this.getProdPrice = this.getProdPrice.bind(this);
    this.getEditMenu = this.getEditMenu.bind(this);
    this.getCardBody = this.getCardBody.bind(this);

    this.state = {
      prodType: 'Software',
      prodName: '',
      prodCategory: '',
      prodPrice: 0,
      prodDevName: '',
      prodDetails: '',
      softies: 0,
      prodImageURL: '',
      productId: '',
      loaded: false
    };
  }

  componentDidMount() {
    let _this = this;

    const docData = this.props.product;
    
    // If this is not a "MySearchItem", but a regular search one, then just set basic and return
    if (!this.props.mySearchItems) {
      if (docData === undefined) return;
      this.setState({
        prodType: docData.prodType,
        prodName: docData.prodName,
        prodCategory: docData.prodCategory,
        prodPrice: docData.prodPrice,
        prodDetails: docData.prodDetails,
        prodDevName: docData.prodDevName,
        softies: docData.softies,
        productId: docData.objectID,
      });
      return;
    }

    this.db
      .collection('software_pages')
      .doc(this.props.productId)
      .get()
      .then(doc => {
        if (doc.exists) {
          let docData = doc.data();
          this.setState({
            prodType: docData.prodType,
            prodName: docData.prodName,
            prodCategory: docData.prodCategory,
            prodPrice: docData.prodPrice,
            prodDetails: docData.prodDetails,
            prodDevName: docData.prodDevName,
            softies: docData.softies,
            productId: docData.prodImageURL,
          });
          if (this.props.mySearchItems === true) {
            this.props.incrementSofties(docData.softies);
          }
        }
      })
      .catch(err => {
        console.log('Error getting document', err);
      });

    // WARNING: Do not use State here as you will have to wait for state before this can be called
    // before it (future: use await and async)
    if (this.props.mySearchItems) {
      const imgRef = this.storage.ref('product_images');
      imgRef.child(this.props.productId).getDownloadURL().then(url => {
        this.setState({
          prodImageURL: url,
          loaded: true
        })
      }).catch(function (error) {
          // Handle any errors
          console.log('Error getting product image', error);
        });
    }
  }

  getHeader() {
    return this.state.prodType + ', ' + this.state.prodCategory;
  }

  getEditMenu() {
    if (this.props.userItem) {
      return (
        <Link
          to={'/edit_product/' + this.props.productId}
          style={{ margin: '0px 0px 6px 12px' }}
        >
          Edit
        </Link>
      );
    } else {
      return <div></div>;
    }
  }

  getProdPrice() {
    return parseInt(this.state.prodPrice) === 0 ? 'Free' : this.state.prodPrice;
  }

  getCardBody() {
    return this.props.mySearchItems ? (
      <Card.Body>
        <Card.Title>
          {' '}
          <Link to={'/view_product/' + this.props.productId}>
            <button style={buttonLinkStyle}>{this.state.prodName}</button>
          </Link>
        </Card.Title>
        <Card.Text style={headerMain}>
          <p style={cardTextStyle}>{this.state.prodDetails}</p>
          {
            this.state.loaded ?
              <img
                id="prodImage"
                alt=""
                src={this.state.prodImageURL}
                width="120"
                height="120"
                className="d-inline-block align-top"
                style={alignTopRight2}
              />
            :
              <div></div>
          }
          
        </Card.Text>
        <Card.Text style={{ margin: '0px 0px 0px 5px' }}>
          <i> {'Softies: ' + this.state.softies} </i>
        </Card.Text>
      </Card.Body>
    ) : (
      <Card.Body>
        <Card.Title>
          {' '}
          <Link to={'/view_product/' + this.props.productId}>
            <button style={buttonLinkStyle}>{this.state.prodName}</button>
          </Link>
        </Card.Title>
        <Card.Text style={headerMain}>{this.state.prodDetails}</Card.Text>
        <Card.Text style={{ margin: '0px 0px 0px 5px' }}>
          <i> {'Softies: ' + this.state.softies} </i>
        </Card.Text>
      </Card.Body>
    );
  }

  render() {
    return (
      <div>
        <Card style={cardStyle}>
          <Card.Header style={headerMain}>
            {this.getHeader()}
            <div style={alignTopRight}>
              <p style={priceText}> {this.getProdPrice()} </p>
            </div>
          </Card.Header>
          <this.getCardBody />
          <this.getEditMenu />
        </Card>
      </div>
    );
  }
}

const cardTextStyle = {
  padding: '0px 300px 0px 0px',
  margin: '0px 75px 0px 5px',
};

const priceText = {
  color: true ? '#00ff00' : '#fff', // Use this to adjust the color of the pricing
  fontStyle: 'italic',
};

const headerMain = {
  position: 'relative',
};

const alignTopRight = {
  position: 'absolute',
  top: '3px',
  right: '12px',
};

const alignTopRight2 = {
  position: 'absolute',
  verticalAlign: 'middle',
  top: '-45px',
  right: '-10px',
  margin: '0px 0px 40px 0px',
};

const buttonLinkStyle = {
  background: 'none!important',
  backgroundColor: 'rgba(0,0,0,0)',
  border: 'none',
  fontFamily: 'arial, sans-serif',
  color: '#0645AD',
  cursor: 'pointer',
  margin: '0px 0px 0px -5px',
};

const cardStyle = {
  margin: '15px 0px 0px 0px',
};

export default SearchItem;
